if (document.getElementById('project_content')) {
  let container = document.getElementById('project_content')
  let read_more_container = document.getElementById('project_content_read_more')
  let read_more_button = read_more_container.getElementsByTagName('button')[0]
  container.style.maxHeight = "350px"
  read_more_container.hidden = false
  read_more_button.addEventListener("click", showContent)

  function showContent() {
    read_more_container.style.bottom = "-100px"
    container.style.maxHeight = "fit-content"
  }
}

if (document.getElementById('plans')) {
  // hide plan img, except the first one by adding opactiy-0 class
  const planImgs = document.querySelectorAll('#plans img.plan-bg');
  planImgs.forEach((img, index) => {
    if (index > 0) {
      img.classList.add('opacity-0');
    }
  });
  // listen for click on plan buttons
  const planButtons = document.querySelectorAll('#plans button');
  planButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      // remove opacity-0 class from all plan imgs
      planImgs.forEach((img) => {
        img.classList.remove('opacity-0');
      });
      // add opacity-0 class to all plan imgs except the one that matches the button
      planImgs.forEach((img, imgIndex) => {
        if (imgIndex !== index) {
          img.classList.add('opacity-0');
        }
      });
    });
  });
}
